<template>
    <div>
        <div class="">
            <elastic-list-component :elasticType="'select'"></elastic-list-component>
        </div>

        <div class="table_wrap">
            <div class="sub_title">등록된 연관제품</div>
            <div class="table_search row has_bc">
                <el-row>
                    <el-col :span="12" >
                        <el-button size="small" @click="deleteSelectItem(selectedRow)">선택삭제</el-button>
                    </el-col>
                    <el-col :span="12" class="text_right"
                            style="text-align: right;float:right;width: 50%;display: inline-block;">
                    </el-col>
                </el-row>
            </div>
            <el-table
                :data="itemData"
                style="width: 100%"
                empty-text="데이터가 없습니다."
                @selection-change="tableSelectChange"
            >
                <el-table-column type="selection" width="55" class-name="text-center"></el-table-column>
                <el-table-column class="table_no" type="index" label="#" width="70" class-name="num" :index="tableIdx"></el-table-column>
                <el-table-column label="관리코드"  class-name="text_center" width="180" prop="i_model" cell="i_model"></el-table-column>
                <el-table-column label="" class-name="text_center" width="150">
                    <template slot-scope="scope">
                        <div class="table_img">
                            <div class="table_img" v-if="scope.row.hasOwnProperty('itemImage') && scope.row.itemImage.length > 0"
                                 :style="`background-image: url(${scope.row.itemImage[0].thumb_url}?${setImageOptions(50, null, 'webp')})`"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="상품명"  class-name="text_center" prop="i_name" cell="i_name"></el-table-column>
                <el-table-column label="가격"  class-name="text_center" prop="i_price" cell="i_price" :sortable="true">
                    <template slot-scope="scope">
                        <span>{{fcComma(scope.row.i_price)}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="진열상태" width=100 class-name="text_center" prop="i_display" cell="i_display">
                    <template slot-scope="scope">{{scope.row.i_display === 1? '진열함' : '진열안함'}}</template>
                </el-table-column>
                <el-table-column
                    align="center"
                    width="200"
                    label=""
                    class-name="table_bottons">
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            type="warning"
                            @click="goDetail(scope.$index, scope.row)">상세</el-button>
                        <el-button
                            size="mini"
                            type="danger"
                            @click="deleteSelectItem([scope.row])">삭제</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="table_search row has_bc">
                <el-row>
                    <el-col :span="12" >
                        <el-button size="small" @click="deleteSelectItem(selectedRow)">선택삭제</el-button>
                    </el-col>
                    <el-col :span="12" class="text_right"
                            style="text-align: right;float:right;width: 50%;display: inline-block;">
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>

</template>

<script>
import ElasticListComponent from "@/components/elastic/ElasticListComponent";
import elasticMixins from "@/mixins/elasticMixins";
import EventBus from "@/mixins/event-bus";
import util from "@/mixins/util";
import imageOption from "@/mixins/imageOption";
import { fcComma } from '@/mixins/common';
import alertMixins from "@/mixins/alertMixins";
import {elasticOption} from "@/api/config";

export default {
    name: "MagazineItemComponent",
    components: {
        ElasticListComponent
    },
    mixins: [elasticMixins, imageOption, alertMixins],
    inject: [],
    provide() {
        return{
            returnSelectItemKeys: this.returnSelectItemKeys,
            addSelectItem: this.addSelectItem,
            deleteSelectItem: this.deleteSelectItem,
        }
    },
    props: {
        magazineKey: {default: 0},
    },
    data() {
        return {
            itemData: [],
            items: [],
            beforeItems: [],
            selectedRow: [],
            editorKey: '',
        }
    },
    created(){
        this.getItemData();
        this.initElastic(elasticOption.index, elasticOption.type)

    },
    mounted() {
        EventBus.$on('updateMagazineItem', this.updateItems)
    },
    beforeDestroy() {
        EventBus.$off('updateMagazineItem')
    },
    computed: {
    },
    methods: {
        getItemData() {
            let params = {
                id: this.magazineKey,
                ip: 0,
                oped: 1,
                opit: 1,
            };
            try {
                this.$api.$magazine.getMagazine(params).then(res => res.Data.Result).then(res => {
                    if(util.isEmpty(res.List) || util.isEmpty(res.List[0].Editor)) {
                        this.errorAlert('데이터를 가져올 수가 없습니다.')
                        this.$router.back();
                        return false;
                    }
                    let Items = res.List[0].Editor[0].Item;
                    this.editorKey = res.List[0].Editor[0].pe_idx;
                    util.Array.each(Items, (itemData, index, arr) => {
                        this.items.push(itemData.i_idx);
                        this.beforeItems.push(itemData.i_idx);
                    })
                    this.getItemElasticData();
                })
            }catch (e) {
                console.log(e)
            }
        },
        getItemElasticData() {
            let body = {
                query: {
                    bool: {
                        must: [
                            {terms: {'i_idx': this.beforeItems}}
                        ]
                    }
                }
            }
            let elasticData = [];
            this.getAllSearch(body, elasticData).then(standByScrollId => {
                this.runClearScrollId(standByScrollId)
                util.Array.each(this.beforeItems, (itemKey, index, arr) => {
                    let item = elasticData.filter(ed => ed.i_idx === itemKey);
                    if(!util.isEmpty(item)) {
                        this.itemData.push(item[0]);
                    }
                })
            })
        },
        tableSelectChange(rows) {
            this.selectedRow = rows;
        },
        tableIdx(index){
            return this.itemData.length - index
        },
        fcComma(price) {
            return fcComma(price);
        },
        returnSelectItemKeys() {
            return this.items;
        },
        goDetail(index, row) {
            this.$router.push("/item/" + row.i_idx)
        },
        addSelectItem(rows=[]) {
            util.Array.each(rows, (row, index, arr) => {
                if(this.items.indexOf(row.i_idx) < 0) {
                    this.items.push(row.i_idx);
                    this.itemData.push(row);
                }
            })
        },
        deleteSelectItem(rows=[]) {
            util.Array.each(rows, (row, index, arr) => {
                let itemsIndex = this.items.indexOf(row.i_idx);
                let dataIndex = this.itemData.findIndex(item => item.i_idx == row.i_idx);
                if(itemsIndex > -1) {
                    this.items.splice(itemsIndex, 1)
                }
                if(dataIndex > -1) {
                    this.itemData.splice(dataIndex, 1)
                }
            })
        },
        _makeParams() {
            let params = {
                p_idx: this.magazineKey,
                editor: {
                    pe_idx: [this.editorKey],
                    items: []
                },
            }
            let updateItemParams = {create: [], delete: []};
            let beforeItems = this.beforeItems.slice();
            util.Array.each(this.items, (itemKey, index, arr) => {
                let itemIndex = beforeItems.indexOf(itemKey);
                if(itemIndex > -1) {
                    beforeItems.splice(itemIndex, 1);
                }else{
                    updateItemParams.create.push(itemKey)
                }
            })
            updateItemParams.delete = beforeItems;
            params.editor.items.push(updateItemParams);
            return params;
        },
        updateItems() {
            let params = this._makeParams();
            try {
                this.$api.$magazine.updateMagazine(params).then(res => res.Data.Result).then(res => {
                    if(res.Info.Type === 1) {
                        this.createAlert({
                            title: '',
                            content: '매거진 연관 상품을 수정하였습니다.',
                            btnText: '확인',
                            hide: () => {
                                this.beforeItems = this.items.slice();
                            }
                        });
                    }else {
                        this.errorAlert('매거진 연관 상품을 수정에 실패하였습니다.')
                    }
                })
            }catch (e) {
                console.log(e)
            }
        },
    },
    watch: {
    },

}
</script>

<style scoped>

</style>
